import React from 'react';
import { track } from '../../../../services/analytics';

interface UserActionsProps {
  variant?: 'desktop' | 'mobile';
}

const UserActions: React.FC<UserActionsProps> = ({ variant = 'desktop' }) => {
  if (variant === 'mobile') {
    return (
      <div className="mobile-actions">
        {/* Central de Atendimento Mobile */}
        <a
          href="/CentralDeAtendimento/central-atendimento"
          className="btn btn-outline-white btn-icon btn-menu rounded transition py-2 px-4 w-100 text-left btn-100 mb-3"
        >
          <img
            src={require('../../../../assets/img/ico-fone.svg').default}
            alt="Central de Atendimento"
            width="16"
            height="16"
            className="mr-3"
          />
          <span>Central de atendimento</span>
        </a>

        {/* Área do Participante Mobile */}
        <a
          href="https://participante.forluz.org.br/"
          className="btn btn-outline-white btn-icon btn-menu rounded transition py-2 px-4 w-100 text-left btn-100 open-login"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track('home_menu_clique', {
            identificador: 'area_participante',
            tipo_destino: 'url',
          })}
        >
          <img
            src={require('../../../../assets/img/user.svg').default}
            alt="Usuário"
            width="15"
            height="16"
            className="mr-3"
          />
          <span>Área do participante</span>
        </a>
      </div>
    );
  }

  return (
    <div className="desktop-actions">
      {/* Central de Atendimento Desktop */}
      <a
        href="/CentralDeAtendimento/central-atendimento"
        className="btn btn-outline-white btn-icon rounded transition"
      >
        <img
          src={require('../../../../assets/img/CentralDeAtendimento.svg').default}
          alt="Central de Atendimento"
          width="24"
          height="24"
          className="mr-2"
        />
        <span>Central de atendimento</span>
      </a>

      {/* Área do Participante Desktop - com classe correta */}
      <a
        href="https://participante.forluz.org.br/"
        className="btn btn-outline-white btn-icon rounded transition open-login participant-btn"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => track('home_menu_clique', {
          identificador: 'area_participante',
          tipo_destino: 'url',
        })}
      >
        <img
          src={require('../../../../assets/img/AreaDoParticipante.svg').default}
          alt="Usuário"
          width="24"
          height="24"
          className="mr-3"
        />
        <span>Área do participante</span>
      </a>
    </div>
  );
};

export default UserActions;
